import { useEffect } from 'react'
import { useHistory, useLocation } from '@fs/zion-router'
import { getMergeUrl, useMergeParams } from './mergeRouteUtil'

// Client-side half of the legacy merge URL redirect; server.js 301s full page loads of the same URLs.
// TODO(TREEWEB-12557): remove legacy merge step URL redirect after 2027-11-30
export default function LegacyMergeStepRedirect(): null {
  const { duplicatePid, survivorPid } = useMergeParams()
  const { hash, search } = useLocation()
  const history = useHistory()

  useEffect(() => {
    history.replace(`${getMergeUrl({ duplicatePid, survivorPid })}${search}${hash}`)
  }, [duplicatePid, hash, history, search, survivorPid])

  return null
}
